import { render, staticRenderFns } from "./PasswordForm.vue?vue&type=template&id=3a7e58a2&scoped=true&"
import script from "./PasswordForm.vue?vue&type=script&lang=ts&"
export * from "./PasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordForm.vue?vue&type=style&index=0&id=3a7e58a2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7e58a2",
  null
  
)

export default component.exports